import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MutualModule } from '@shared/mutual/mutual.module';
import { IdentifierUpdateModule } from '@shared/identifier-update/identifier-update.module';
import { InputPhoneModule } from '@shared/input-phone/input-phone.module';
import { AddressModule } from '@shared/address/address.module';
import { PipesSharedModule } from '@shared/pipes-shared/pipes-shared.module';
import { LclEntityEditComponent, LclEntityViewComponent, LclIdentifierUpdateComponent } from './components';

@NgModule({
  declarations: [LclEntityEditComponent, LclEntityViewComponent, LclIdentifierUpdateComponent],
  imports: [CommonModule, MutualModule, IdentifierUpdateModule, InputPhoneModule, AddressModule, PipesSharedModule],
  exports: [LclEntityEditComponent, LclEntityViewComponent],
})
export class LclEntitiesModule {}
